import { render, staticRenderFns } from "./BusinessAreas.vue?vue&type=template&id=3d52fc1e&scoped=true&"
import script from "./BusinessAreas.vue?vue&type=script&lang=ts&"
export * from "./BusinessAreas.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessAreas.vue?vue&type=style&index=0&id=3d52fc1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d52fc1e",
  null
  
)

export default component.exports